import { render, staticRenderFns } from "./NewSalaryReceipt.vue?vue&type=template&id=49df4c76&scoped=true&"
import script from "./NewSalaryReceipt.vue?vue&type=script&lang=js&"
export * from "./NewSalaryReceipt.vue?vue&type=script&lang=js&"
import style0 from "./NewSalaryReceipt.vue?vue&type=style&index=0&id=49df4c76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49df4c76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49df4c76')) {
      api.createRecord('49df4c76', component.options)
    } else {
      api.reload('49df4c76', component.options)
    }
    module.hot.accept("./NewSalaryReceipt.vue?vue&type=template&id=49df4c76&scoped=true&", function () {
      api.rerender('49df4c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Payrolls/NewSalaryReceipt.vue"
export default component.exports